(function () {
  "use strict";

  var form = document.getElementById("cod-order-form");
  if (!form) return;

  try {
    var params = new URLSearchParams(window.location.search);
    var utmKeys = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];
    utmKeys.forEach(function (key) {
      var val = params.get(key);
      if (val) {
        sessionStorage.setItem(key, val);
      }
    });
  } catch (e) {}

  var proxyUrl = form.dataset.proxyUrl;
  var productId = form.dataset.productId;
  var productTitle = form.dataset.productTitle;
  var productImage = form.dataset.productImage;
  var currentPrice = parseInt(form.dataset.productPrice, 10);
  var currentVariantId = form.dataset.variantId;
  var currentVariantTitle = form.dataset.variantTitle;
  var currentVariantSku = form.dataset.variantSku || "";

  var variants = [];
  try {
    var variantsEl = document.getElementById("cod-product-variants");
    if (variantsEl) variants = JSON.parse(variantsEl.textContent);
  } catch {}

  var wilayasData = [];
  var activeOffers = [];
  var pixelIds = {};
  var pixelsReady = false;
  var pixelEventKeys = {};
  var selectedTier = null;
  var selectedOffer = null;
  var shippingCost = 0;
  var submitting = false;
  var dialCode = "+502";
  var activeCurrency = "";
  var activeCountry = "GT";
  var formConfig = {
    formTitle: "Completa tu pedido",
    formSubtitle: "Ingresa tu número de teléfono y confirmaremos el pedido",
    buttonText: "Pedir ahora",
    stickyButtonText: "Pedir ahora - Pago contra entrega",
    buttonColor: "#111111",
    buttonTextColor: "#ffffff",
    accentColor: "#111111",
    formBackgroundColor: "#ffffff",
    fieldBackgroundColor: "#f9faf7",
    fieldTextColor: "#111827",
    borderColor: "#dfe5dc",
    iconBackgroundColor: "#e7ece5",
    borderWidth: 1,
    formShadow: 12,
    labelAlignment: "right",
    stickyEnabled: true,
    quantityEnabled: true,
    secondaryPhoneEnabled: false,
    notesEnabled: false,
    addressEnabled: true,
    trustBadgesEnabled: true,
    showPriceSummary: false,
    showAssurance: false,
    showUrgency: true,
    showStock: true,
    labelsVisible: true,
    compactMode: false,
    fieldStyle: "soft",
    priceStyle: "dark",
    stickyMode: "summary",
    formPlacement: "inline",
    buttonRadius: 8,
    urgencyText: "¡Oferta limitada y existencias limitadas!",
    stockText: "Pocas unidades disponibles",
    successTitle: "¡Pedido recibido con éxito!",
    successText: "Nos pondremos en contacto pronto para confirmar el pedido.",
    fields: {},
  };

  form.setAttribute("novalidate", "true");

  function ensureFieldInput(key) {
    var idMap = {
      name: { id: "cod-name", type: "text", tag: "INPUT", name: "customerName" },
      phone: { id: "cod-phone", type: "tel", tag: "INPUT", name: "customerPhone" },
      phoneAlt: { id: "cod-phone-alt", type: "tel", tag: "INPUT", name: "customerPhoneAlt" },
      address: { id: "cod-address", type: "text", tag: "INPUT", name: "address" },
      postalCode: { id: "cod-postal-code", type: "text", tag: "INPUT", name: "postalCode" },
      city: { id: "cod-city", type: "text", tag: "INPUT", name: "city", label: "Ciudad/Localidad", placeholder: "Introduce tu ciudad" },
      province: { id: "cod-province", type: "select", tag: "SELECT", name: "province" },
      wilaya: { id: "cod-wilaya", type: "select", tag: "SELECT", name: "wilayaId" },
      moughataa: { id: "cod-moughataa", type: "select", tag: "SELECT", name: "moughataaId" },
      notes: { id: "cod-notes", type: "textarea", tag: "TEXTAREA", name: "notes" },
    };
    var info = idMap[key];
    if (!info) return null;
    var el = document.getElementById(info.id);
    if (el) return el;

    var wrapper = document.createElement("div");
    wrapper.className = "cod-form__field";
    wrapper.id = info.id + "-field";

    var label = document.createElement("label");
    label.className = "cod-form__label";
    label.setAttribute("for", info.id);

    var input;
    if (info.tag === "SELECT") {
      input = document.createElement("select");
      input.className = "cod-form__select";
      var opt = document.createElement("option");
      opt.value = "";
      opt.textContent = "Seleccionar";
      input.appendChild(opt);
    } else if (info.tag === "TEXTAREA") {
      input = document.createElement("textarea");
      input.className = "cod-form__textarea";
      input.rows = 2;
    } else {
      input = document.createElement("input");
      input.type = info.type;
      input.className = "cod-form__input";
    }
    input.id = info.id;
    input.name = info.name;

    var errorSpan = document.createElement("span");
    errorSpan.className = "cod-form__error";
    errorSpan.id = info.id + "-error";

    if (info.label) {
      label.innerHTML = info.label + ' <span class="cod-form__required">*</span>';
    }
    if (info.placeholder) {
      input.setAttribute("placeholder", info.placeholder);
    }
    wrapper.appendChild(label);
    wrapper.appendChild(input);
    wrapper.appendChild(errorSpan);

    var submitBtnEl = document.getElementById("cod-submit-btn");
    var notesEl = document.getElementById("cod-notes-field") || document.getElementById("cod-notes");
    var anchor = notesEl ? (notesEl.closest(".cod-form__field") || notesEl) : submitBtnEl;
    if (anchor && anchor.parentNode) {
      anchor.parentNode.insertBefore(wrapper, anchor);
    } else {
      form.appendChild(wrapper);
    }

    return input;
  }

  // ─── DOM refs ───
  var nameInput = ensureFieldInput("name");
  var phoneInput = ensureFieldInput("phone");
  var phoneAltInput = ensureFieldInput("phoneAlt");
  var wilayaSelect = ensureFieldInput("wilaya");
  var moughataaSelect = ensureFieldInput("moughataa");
  var addressInput = ensureFieldInput("address");
  var postalCodeInput = ensureFieldInput("postalCode");
  var cityInput = ensureFieldInput("city");
  var provinceSelect = ensureFieldInput("province");
  var warningBanner = document.getElementById("cod-warning-banner");
  var warningBannerText = document.getElementById("cod-warning-banner-text");
  var notesInput = ensureFieldInput("notes");
  var quantityInput = document.getElementById("cod-quantity");
  var qtyMinus = document.getElementById("cod-qty-minus");
  var qtyPlus = document.getElementById("cod-qty-plus");
  var submitBtn = document.getElementById("cod-submit-btn");
  var submitText = document.getElementById("cod-submit-text");
  var submitSpinner = document.getElementById("cod-submit-spinner");
  var successMessage = document.getElementById("cod-success-message");
  var errorMessage = document.getElementById("cod-error-message");
  var errorText = document.getElementById("cod-error-text");
  var unitPriceEl = document.getElementById("cod-unit-price");
  var shippingPriceEl = document.getElementById("cod-shipping-price");
  var totalPriceEl = document.getElementById("cod-total-price");
  var stickyPriceEl = document.getElementById("cod-sticky-price");
  var topPriceEl = document.getElementById("cod-top-price");
  var topComparePriceEl = document.getElementById("cod-top-compare-price");
  var currentComparePrice = parseInt(form.dataset.comparePrice || "0", 10);
  var stickyCta = document.getElementById("cod-sticky-cta");
  var offersEl = document.getElementById("cod-quantity-offers");
  var variantSelects = form.querySelectorAll(".cod-variant-select");
  var placementReady = false;
  var locationListenerReady = false;

  // ─── Init ───
  form.classList.remove("cod-form--booting");
  applyCachedBootstrap();
  loadBootstrap();
  initLocationSelector();
  initQuantity();
  initVariants();
  initStickyObserver();

  submitBtn.addEventListener("click", handleSubmit);

  // ─── Fast Bootstrap ───
  function bootstrapCacheKey() {
    return "cod-bootstrap:" + productId;
  }

  function applyCachedBootstrap() {
    try {
      var cached = window.localStorage && window.localStorage.getItem(bootstrapCacheKey());
      if (!cached) return false;
      var parsed = JSON.parse(cached);
      if (!parsed || !parsed.savedAt || Date.now() - parsed.savedAt > 1000 * 5) return false;
      applyBootstrap(parsed.data || {}, true);
      return true;
    } catch {
      return false;
    }
  }

  function cacheBootstrap(data) {
    try {
      if (!window.localStorage) return;
      window.localStorage.setItem(
        bootstrapCacheKey(),
        JSON.stringify({ savedAt: Date.now(), data: data })
      );
    } catch {}
  }

  function loadBootstrap() {
    var sharedData =
      window.__COD_BOOTSTRAP_DATA && window.__COD_BOOTSTRAP_DATA[productId];
    if (sharedData) {
      cacheBootstrap(sharedData);
      applyBootstrap(sharedData, false);
      return;
    }

    var sharedPromise =
      window.__COD_BOOTSTRAP_PROMISE && window.__COD_BOOTSTRAP_PROMISE[productId];
    if (sharedPromise && typeof sharedPromise.then === "function") {
      sharedPromise
        .then(function (data) {
          if (!data) throw new Error("Empty bootstrap");
          cacheBootstrap(data);
          applyBootstrap(data, false);
        })
        .catch(function () {
          if (form.classList.contains("cod-form--booting")) {
            applyFormConfig();
            initPixels();
            initPixelViewContent();
          }
        });
      return;
    }

    fetch(proxyUrl + "/bootstrap?product_id=" + encodeURIComponent(productId), { cache: "no-store" })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        cacheBootstrap(data);
        applyBootstrap(data, false);
      })
      .catch(function () {
        if (form.classList.contains("cod-form--booting")) {
          applyFormConfig();
          initPixels();
          initPixelViewContent();
        }
      });
  }

  function applyBootstrap(data, fromCache) {
    if (data.form) {
      Object.keys(data.form).forEach(function (key) {
        if (data.form[key] !== null && data.form[key] !== undefined) {
          formConfig[key] = data.form[key];
        }
      });
    }

    if (formConfig.formPlacement === "disabled") {
      form.style.display = "none";
      if (stickyCta) stickyCta.style.display = "none";
      var launcher = document.querySelector(".cod-form-launcher");
      if (launcher) launcher.style.display = "none";
      var overlay = document.querySelector(".cod-form-modal");
      if (overlay) overlay.style.display = "none";
      return;
    }
    if (data.dialCode) dialCode = data.dialCode;
    if (data.country) activeCountry = data.country;
    activeCurrency = "";

    pixelIds = data.pixels || pixelIds || {};
    wilayasData = data.locations && Array.isArray(data.locations.wilayas)
      ? data.locations.wilayas
      : wilayasData;
    activeOffers = Array.isArray(data.offers) ? data.offers : activeOffers;
    populateLocationOptions();
    renderOffers();
    applyFormConfig();
    if (formConfig.formPlacement === "stepper" || stepperInitialized) {
      initStepper();
      renderStep();
    }
    if (!fromCache || !pixelsReady) {
      initPixels();
      initPixelViewContent();
    }
  }

  function applyFormConfig() {
    var isEur = Boolean(formConfig.country === 'ES' || formConfig.isEur);
    form.style.setProperty("--cod-button-color", formConfig.buttonColor);
    form.style.setProperty("--cod-button-text-color", formConfig.buttonTextColor || "#ffffff");
    form.style.setProperty("--cod-accent-color", formConfig.accentColor);
    form.style.setProperty("--cod-form-bg", formConfig.formBackgroundColor || "#ffffff");
    form.style.setProperty("--cod-field-bg", formConfig.fieldBackgroundColor || "#f9faf7");
    form.style.setProperty("--cod-field-text", formConfig.fieldTextColor || "#111827");
    form.style.setProperty("--cod-border-color", formConfig.borderColor || "#dfe5dc");
    form.style.setProperty("--cod-icon-bg", formConfig.iconBackgroundColor || "#e7ece5");
    form.style.setProperty("--cod-border-width", (formConfig.borderWidth ?? 1) + "px");
    form.style.setProperty("--cod-form-shadow", "0 " + Math.max(4, Number(formConfig.formShadow || 0)) + "px " + Math.max(10, Number(formConfig.formShadow || 0) * 3) + "px rgba(15, 23, 42, " + (Number(formConfig.formShadow || 0) ? "0.12" : "0") + ")");
    form.style.setProperty("--cod-button-radius", (formConfig.buttonRadius || 8) + "px");
    document.documentElement.style.setProperty("--cod-button-color", formConfig.buttonColor);
    document.documentElement.style.setProperty("--cod-button-text-color", formConfig.buttonTextColor || "#ffffff");
    form.dataset.fieldStyle = formConfig.fieldStyle || "soft";
    form.dataset.priceStyle = formConfig.priceStyle || "dark";
    form.dataset.placement = formConfig.formPlacement || "inline";
    form.dataset.labelAlignment = formConfig.labelAlignment || "right";
    form.classList.toggle("cod-form--compact", Boolean(formConfig.compactMode));
    form.classList.toggle("cod-form--hide-labels", !formConfig.labelsVisible);

    var title = form.querySelector(".cod-form__title");
    var subtitle = form.querySelector(".cod-form__subtitle");
    var urgency = form.querySelector(".cod-form__urgency");
    var stock = form.querySelector(".cod-form__stock");
    var assurance = form.querySelector(".cod-form__assurance");
    var priceDisplay = form.querySelector(".cod-form__price-display");
    var successTitle = form.querySelector(".cod-form__success h3");
    var successText = form.querySelector(".cod-form__success-text");

    if (title) title.textContent = formConfig.formTitle;
    if (subtitle) subtitle.textContent = formConfig.formSubtitle;
    if (urgency) urgency.textContent = formConfig.urgencyText;
    if (stock) stock.textContent = formConfig.stockText;
    if (successTitle) successTitle.textContent = formConfig.successTitle;
    if (successText) successText.textContent = formConfig.successText;
    if (submitText) submitText.textContent = formConfig.buttonText;
    if (stickyCta) {
      var stickyButton = stickyCta.querySelector(".cod-sticky-cta__btn");
      var stickyButtonText = stickyCta.querySelector(".cod-sticky-cta__btn-text");
      if (stickyButton) {
        stickyButton.style.backgroundColor = formConfig.buttonColor || "#111111";
        stickyButton.style.color = formConfig.buttonTextColor || "#ffffff";
      }
      if (stickyButtonText) {
        stickyButtonText.textContent = formConfig.stickyButtonText || formConfig.buttonText;
      }
    }

    submitBtn.style.backgroundColor = formConfig.buttonColor;
    submitBtn.style.color = formConfig.buttonTextColor || "#ffffff";
    submitBtn.style.borderRadius = (formConfig.buttonRadius || 8) + "px";

    nameInput = ensureFieldInput("name");
    phoneInput = ensureFieldInput("phone");
    phoneAltInput = ensureFieldInput("phoneAlt");
    wilayaSelect = ensureFieldInput("wilaya");
    moughataaSelect = ensureFieldInput("moughataa");
    addressInput = ensureFieldInput("address");
    postalCodeInput = ensureFieldInput("postalCode");
    cityInput = ensureFieldInput("city");
    provinceSelect = ensureFieldInput("province");
    notesInput = ensureFieldInput("notes");

    reorderFields();
    renderCustomFields();

    applyPhonePrefix(phoneInput);
    applyPhonePrefix(phoneAltInput);

    applyFieldConfig("name", nameInput);
    applyFieldConfig("phone", phoneInput);
    applyFieldConfig("phoneAlt", phoneAltInput);
    applyFieldConfig("address", addressInput);
    applyFieldConfig("postalCode", postalCodeInput);
    applyFieldConfig("city", cityInput);
    applyFieldConfig("province", provinceSelect);
    applyFieldConfig("wilaya", wilayaSelect);
    applyFieldConfig("moughataa", moughataaSelect);
    applyFieldConfig("notes", notesInput);

    if (isEur && provinceSelect) {
      populateProvinceSelect();
    }

    if (formConfig.warningBannerEnabled && warningBanner) {
      if (warningBannerText && formConfig.warningBannerText) {
        warningBannerText.textContent = formConfig.warningBannerText;
      }
      warningBanner.style.display = "block";
    } else if (warningBanner) {
      warningBanner.style.display = "none";
    }

    if (urgency) urgency.style.display = formConfig.showUrgency ? "" : "none";
    if (stock) stock.style.display = formConfig.showStock ? "" : "none";
    if (assurance) assurance.style.display = formConfig.showAssurance ? "" : "none";
    if (priceDisplay) priceDisplay.style.display = formConfig.showPriceSummary ? "" : "none";

    document.querySelectorAll(".cod-trust-badges").forEach(function (el) {
      el.style.display = formConfig.trustBadgesEnabled ? "" : "none";
    });

    if ((!formConfig.stickyEnabled || formConfig.stickyMode === "disabled") && stickyCta) {
      stickyCta.remove();
      stickyCta = null;
    }

    initPlacement();
  }

  function applyPhonePrefix(input) {
    if (!input) return;
    var existingPrefix = input.parentNode.querySelector("span");
    if (existingPrefix && input.parentNode.classList.contains("cod-phone-input")) {
      existingPrefix.textContent = dialCode;
      return;
    }
    var wrapper = document.createElement("div");
    wrapper.className = "cod-phone-input";
    var prefix = document.createElement("span");
    prefix.textContent = dialCode;
    input.parentNode.insertBefore(wrapper, input);
    wrapper.appendChild(prefix);
    wrapper.appendChild(input);
    input.setAttribute("inputmode", "numeric");
    input.setAttribute("maxlength", "14");
  }

  function initPlacement() {
    var placement = formConfig.formPlacement || "inline";
    if (!placementReady) {
      placementReady = true;
      if (placement === "popup" || placement === "sticky") {
        var launcher = document.createElement("button");
        launcher.type = "button";
        launcher.className = "cod-form-launcher";
        launcher.textContent = formConfig.buttonText || "Pedir ahora";
        launcher.style.backgroundColor = formConfig.buttonColor || "#111111";
        form.parentNode.insertBefore(launcher, form);

        var overlay = document.createElement("div");
        overlay.className = "cod-form-modal";
        var dialog = document.createElement("div");
        dialog.className = "cod-form-modal__dialog";
        var close = document.createElement("button");
        close.type = "button";
        close.className = "cod-form-modal__close";
        close.textContent = "×";
        form.parentNode.insertBefore(overlay, form);
        overlay.appendChild(dialog);
        dialog.appendChild(close);
        dialog.appendChild(form);
        form.classList.add("cod-form--in-modal");

        function openModal() {
          overlay.classList.add("is-open");
          document.documentElement.classList.add("cod-modal-open");
        }
        launcher.addEventListener("click", openModal);
        if (stickyCta) {
          var stickyButton = stickyCta.querySelector(".cod-sticky-cta__btn");
          if (stickyButton) {
            stickyButton.addEventListener("click", function (event) {
              event.preventDefault();
              openModal();
            });
          }
        }
        close.addEventListener("click", closeModal);
        overlay.addEventListener("click", function (event) {
          if (event.target === overlay) closeModal();
        });
        function closeModal() {
          overlay.classList.remove("is-open");
          document.documentElement.classList.remove("cod-modal-open");
        }
      }
    }

    if (placement === "stepper") {
      initStepper();
    }
    form.classList.remove("cod-form--booting");
  }

  var stepperIndex = 0;
  var stepperInitialized = false;

  function isFieldNodeEnabled(node) {
    if (!node) return false;
    if (node.dataset && node.dataset.fieldEnabled === "false") return false;
    if (node.style && node.style.display === "none") return false;
    var inp = node.querySelector("input, select, textarea");
    if (inp && inp.disabled) return false;
    return true;
  }

  function getStepperSteps() {
    var allGroups = Array.prototype.slice.call(
      form.querySelectorAll(".cod-form__variants, #cod-quantity-offers, .cod-form__field, .cod-form__row")
    );
    var steps = [
      {
        label: "Oferta",
        nodes: allGroups.filter(function (el) {
          return el.id === "cod-quantity-offers" || el.classList.contains("cod-form__variants");
        }),
      },
      {
        label: "Datos",
        nodes: allGroups.filter(function (el) {
          return (hasInput(el, ["cod-name", "cod-phone", "cod-phone-alt"]) || hasCustomInput(el)) && isFieldNodeEnabled(el);
        }),
      },
      {
        label: "Envío",
        nodes: allGroups.filter(function (el) {
          return hasInput(el, ["cod-wilaya", "cod-moughataa", "cod-address", "cod-postal-code", "cod-city", "cod-province", "cod-notes"]) && isFieldNodeEnabled(el);
        }),
      },
    ].filter(function (step, stepIdx) {
      step.nodes = uniqueNodes(step.nodes);
      return stepIdx === 0 || step.nodes.length > 0;
    });
    return { allGroups: allGroups, steps: steps };
  }

  function renderStep() {
    var stepperData = getStepperSteps();
    var allGroups = stepperData.allGroups;
    var steps = stepperData.steps;

    if (!steps.length) return;
    if (stepperIndex >= steps.length) stepperIndex = steps.length - 1;

    allGroups.forEach(function (group) {
      group.classList.add("cod-step-hidden");
    });
    if (steps[stepperIndex]) {
      steps[stepperIndex].nodes.forEach(function (group) {
        if (isFieldNodeEnabled(group)) {
          group.classList.remove("cod-step-hidden");
          group.style.display = "";
        }
      });
    }

    var liveProgress = form.querySelector(".cod-form-stepper-progress");
    if (liveProgress) {
      liveProgress.querySelectorAll("span").forEach(function (dot, i) {
        dot.classList.toggle("is-active", i === stepperIndex);
        dot.classList.toggle("is-done", i < stepperIndex);
      });
    }

    var liveNav = form.querySelector(".cod-form-stepper-nav");
    var livePrev = liveNav ? liveNav.querySelector(".cod-form-stepper__prev") : null;
    var liveNext = liveNav ? liveNav.querySelector(".cod-form-stepper__next") : null;

    if (livePrev) livePrev.disabled = stepperIndex === 0;
    if (liveNext) liveNext.style.display = stepperIndex === steps.length - 1 ? "none" : "";
    submitBtn.style.display = stepperIndex === steps.length - 1 ? "" : "none";

    var submitContainer = form.querySelector(".cod-form__submit");
    if (liveNav && submitContainer && submitContainer.parentNode) {
      submitContainer.parentNode.insertBefore(liveNav, submitContainer);
    }

    if (stepperInitialized) {
      try {
        form.scrollIntoView({ behavior: "smooth", block: "start" });
      } catch (e) {}
    }
  }

  function initStepper() {
    stepperInitialized = true;
    stepperIndex = 0;
    form.classList.add("cod-form--stepper-ready");

    var stepperData = getStepperSteps();
    var steps = stepperData.steps;
    if (!steps.length) return;

    var existingProgress = form.querySelector(".cod-form-stepper-progress");
    var existingNav = form.querySelector(".cod-form-stepper-nav");
    if (existingProgress) existingProgress.remove();
    if (existingNav) existingNav.remove();

    var progress = document.createElement("div");
    progress.className = "cod-form-stepper-progress";
    progress.innerHTML = steps
      .map(function (step, i) {
        var cls = i === stepperIndex ? "is-active" : (i < stepperIndex ? "is-done" : "");
        return '<span data-step="' + i + '" class="' + cls + '"><b>' + (i + 1) + '</b><small>' + step.label + '</small></span>';
      })
      .join("");
    var header = form.querySelector(".cod-form__header");
    if (header) {
      header.insertAdjacentElement("afterend", progress);
    } else {
      form.insertBefore(progress, form.firstChild);
    }

    var nav = document.createElement("div");
    nav.className = "cod-form-stepper-nav";
    nav.innerHTML =
      '<button type="button" class="cod-form-stepper__prev">Anterior</button>' +
      '<button type="button" class="cod-form-stepper__next">Siguiente</button>';

    var submitContainer = form.querySelector(".cod-form__submit");
    if (submitContainer && submitContainer.parentNode) {
      submitContainer.parentNode.insertBefore(nav, submitContainer);
    } else {
      form.appendChild(nav);
    }

    progress.querySelectorAll("span").forEach(function (dot, i) {
      dot.style.cursor = "pointer";
      dot.addEventListener("click", function (e) {
        if (e) e.preventDefault();
        var currentSteps = getStepperSteps().steps;
        if (i > stepperIndex && !validateStep(currentSteps[stepperIndex])) return;
        stepperIndex = i;
        renderStep();
      });
    });

    var prev = nav.querySelector(".cod-form-stepper__prev");
    var next = nav.querySelector(".cod-form-stepper__next");

    prev.addEventListener("click", function (e) {
      if (e) e.preventDefault();
      stepperIndex = Math.max(0, stepperIndex - 1);
      renderStep();
    });

    next.addEventListener("click", function (e) {
      if (e) e.preventDefault();
      var currentSteps = getStepperSteps().steps;
      if (!validateStep(currentSteps[stepperIndex])) return;
      stepperIndex = Math.min(currentSteps.length - 1, stepperIndex + 1);
      renderStep();
    });

    renderStep();
  }

  function hasInput(node, ids) {
    return ids.some(function (id) {
      return node.id === id || Boolean(node.querySelector("#" + id));
    });
  }

  function hasCustomInput(node) {
    return (
      (node.id && node.id.indexOf("cod-custom-") === 0) ||
      Boolean(node.querySelector("input[id^='cod-custom-'], select[id^='cod-custom-']"))
    );
  }

  function uniqueNodes(nodes) {
    return nodes.filter(function (node, index) {
      return nodes.indexOf(node) === index;
    });
  }

  function validatePhoneNumber(value, country) {
    var digits = String(value || "").replace(/\D/g, "");
    if (country === "GT") {
      return /^\d{8}$/.test(digits) || /^502\d{8}$/.test(digits);
    }
    if (country === "PA") {
      return /^\d{7,8}$/.test(digits) || /^507\d{7,8}$/.test(digits);
    }
    if (country === "CR") {
      return /^\d{8}$/.test(digits) || /^506\d{8}$/.test(digits);
    }
    if (country === "SV") {
      return /^\d{8}$/.test(digits) || /^503\d{8}$/.test(digits);
    }
    return digits.length >= 6 && digits.length <= 15;
  }

  function validateStep(step) {
    if (!step || !Array.isArray(step.nodes)) return true;
    clearErrors();
    var valid = true;
    var firstErrorInput = null;
    step.nodes.forEach(function (node) {
      node.querySelectorAll("input, select, textarea").forEach(function (input) {
        var wrapper = input.closest(".cod-form__field") || input.closest(".cod-form__row") || input.parentNode;
        if (!input.id || !input.required) return;
        if (wrapper) {
          if (wrapper.classList.contains("cod-step-hidden")) return;
          if (window.getComputedStyle(wrapper).display === "none") return;
        }
        var value = String(input.value || "").trim();
        if (!value) {
          showFieldError(input.id, "Este campo es obligatorio");
          valid = false;
          if (!firstErrorInput) firstErrorInput = input;
        }
        if (input.id === "cod-phone" && value) {
          if (!validatePhoneNumber(input.value, activeCountry)) {
            var digitsMsg = activeCountry === "PA" ? "7 u 8 dígitos" : "8 dígitos";
            showFieldError(input.id, "Número de teléfono inválido (debe tener " + digitsMsg + ")");
            valid = false;
            if (!firstErrorInput) firstErrorInput = input;
          }
        }
      });
    });
    if (firstErrorInput) {
      try {
        firstErrorInput.scrollIntoView({ behavior: "smooth", block: "center" });
        firstErrorInput.focus();
      } catch (e) {}
    }
    return valid;
  }

  function reorderFields() {
    var activeTag = document.activeElement ? document.activeElement.tagName : "";
    if (activeTag === "INPUT" || activeTag === "SELECT" || activeTag === "TEXTAREA") return;

    var fieldOrder = Array.isArray(formConfig.fieldOrder) && formConfig.fieldOrder.length > 0
      ? formConfig.fieldOrder
      : ["name", "phone", "phoneAlt", "wilaya", "moughataa", "address", "postalCode", "city", "province", "notes"];

    var submitBtnEl = document.getElementById("cod-submit-btn");
    var parent = submitBtnEl ? submitBtnEl.parentNode : form;
    if (!parent) return;

    fieldOrder.forEach(function (key) {
      var input = ensureFieldInput(key);
      if (input) {
        var wrapper = input.closest(".cod-form__field") || input.closest(".cod-form__row");
        if (wrapper && wrapper.parentNode === parent && wrapper.nextSibling !== submitBtnEl) {
          parent.insertBefore(wrapper, submitBtnEl);
        }
      }
    });
  }

  function renderCustomFields() {
    var activeTag = document.activeElement ? document.activeElement.tagName : "";
    if (activeTag === "INPUT" || activeTag === "SELECT" || activeTag === "TEXTAREA") return;

    var customFields = formConfig.customFields || [];
    var submitBtnEl = document.getElementById("cod-submit-btn");
    var parent = submitBtnEl ? submitBtnEl.parentNode : form;
    if (!parent) return;

    customFields.forEach(function (field) {
      var fieldId = "cod-custom-" + field.id;
      var existing = document.getElementById(fieldId);

      if (!field.enabled) {
        if (existing) {
          var w = existing.closest(".cod-form__field");
          if (w) w.style.display = "none";
        }
        return;
      }

      if (existing) {
        var w = existing.closest(".cod-form__field");
        if (w) w.style.display = "block";
        return;
      }

      var wrapper = document.createElement("div");
      wrapper.className = "cod-form__field cod-custom-field-wrapper";

      var labelEl = document.createElement("label");
      labelEl.className = "cod-form__label";
      labelEl.htmlFor = fieldId;
      var reqSpan = field.required ? ' <span class="cod-form__required">*</span>' : "";
      labelEl.innerHTML = field.label + reqSpan;
      wrapper.appendChild(labelEl);

      var input;
      if (field.type === "textarea") {
        input = document.createElement("textarea");
        input.className = "cod-form__textarea";
      } else if (field.type === "select") {
        input = document.createElement("select");
        input.className = "cod-form__select";
        var placeholderOption = document.createElement("option");
        placeholderOption.value = "";
        placeholderOption.textContent = field.placeholder || "Selecciona...";
        placeholderOption.disabled = true;
        placeholderOption.selected = true;
        input.appendChild(placeholderOption);

        (field.options || []).forEach(function (opt) {
          var o = document.createElement("option");
          o.value = opt;
          o.textContent = opt;
          input.appendChild(o);
        });
      } else {
        input = document.createElement("input");
        input.type = field.type === "number" ? "number" : "text";
        input.className = "cod-form__input";
      }

      input.id = fieldId;
      input.placeholder = field.placeholder || "";
      input.dataset.customId = field.id;
      input.dataset.customLabel = field.label;
      if (field.required) input.required = true;

      var errorSpan = document.createElement("span");
      errorSpan.className = "cod-form__error";
      errorSpan.id = fieldId + "-error";

      wrapper.appendChild(input);
      wrapper.appendChild(errorSpan);

      if (submitBtnEl && submitBtnEl.parentNode === parent) {
        parent.insertBefore(wrapper, submitBtnEl);
      } else {
        form.appendChild(wrapper);
      }
    });
  }

  function applyFieldConfig(key, input) {
    if (!input) return;
    var settings = (formConfig.fields && formConfig.fields[key]) || {};
    var enabled = isFieldEnabled(key);
    var required = isFieldRequired(key);

    var wrapper = input.closest(".cod-form__field");
    if (wrapper) {
      wrapper.dataset.fieldEnabled = enabled ? "true" : "false";
    }

    toggleClosest(input, ".cod-form__field", Boolean(enabled));

    if (settings.placeholder) {
      if (input.tagName === "SELECT") {
        var first = input.querySelector("option");
        if (first && first.value === "") first.textContent = settings.placeholder;
      } else {
        input.setAttribute("placeholder", settings.placeholder);
      }
    }

    var label = wrapper ? wrapper.querySelector(".cod-form__label") : null;
    if (label && settings.label) {
      var reqSpan = required ? ' <span class="cod-form__required">*</span>' : "";
      label.innerHTML = settings.label + reqSpan;
    }

    input.required = Boolean(required && enabled);
    input.disabled = !enabled;
    if (!enabled) {
      input.value = "";
    }
  }

  function toggleClosest(input, selector, visible) {
    if (!input) return;
    var wrapper = input.closest(selector);
    if (wrapper) wrapper.style.display = visible ? "" : "none";
    var row = input.closest(".cod-form__row");
    if (row) {
      var anyVisible = Array.prototype.slice.call(row.querySelectorAll(".cod-form__field")).some(function (field) {
        return field.style.display !== "none";
      });
      row.style.display = anyVisible ? "" : "none";
    }
  }

  function populateProvinceSelect() {
    if (!provinceSelect) return;
    if (provinceSelect.options.length > 1) return; // already populated

    var spainProvinces = [
      "Álava", "Albacete", "Alicante", "Almería", "Asturias", "Ávila", "Badajoz", "Barcelona", "Burgos", "Cáceres",
      "Cádiz", "Cantabria", "Castellón", "Ciudad Real", "Córdoba", "La Coruña", "Cuenca", "Gerona", "Granada", "Guadalajara",
      "Guipúzcoa", "Huelva", "Huesca", "Jaén", "León", "Lérida", "Lugo", "Madrid", "Málaga", "Murcia",
      "Navarra", "Orense", "Palencia", "Pontevedra", "La Rioja", "Salamanca", "Segovia", "Sevilla", "Soria", "Tarragona",
      "Santa Cruz de Tenerife", "Teruel", "Toledo", "Valencia", "Valladolid", "Vizcaya", "Zamora", "Zaragoza"
    ];

    spainProvinces.forEach(function (prov) {
      var opt = document.createElement("option");
      opt.value = prov;
      opt.textContent = prov;
      provinceSelect.appendChild(opt);
    });
  }

  // ─── Offers ───
  function loadOffers() {
    if (!offersEl) return;
    fetch(proxyUrl + "/upsells?product_id=" + encodeURIComponent(productId), { cache: "no-store" })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        activeOffers = data.offers || [];
        renderOffers();
      })
      .catch(function () {});
  }

  function renderOffers() {
    if (!offersEl) return;
    var offer = activeOffers.find(function (item) {
      return item.type === "QUANTITY_DISCOUNT" || item.type === "BUNDLE";
    }) || activeOffers[0] || {
      name: "Elige la oferta adecuada para ti",
      titleAr: "Elige la oferta adecuada para ti",
      descriptionAr: "Envío gratis y pago contra entrega",
      badgeText: "Envío gratis",
      quantityTiers: [
        {
          quantity: 1,
          labelAr: "1 unidad",
          badgeText: "Más vendido",
          price: Math.round(currentPrice / 100),
        },
      ],
    };
    var tiers = Array.isArray(offer.quantityTiers) ? offer.quantityTiers : [];
    if (!tiers.length) {
      tiers = [{ quantity: 1, labelAr: "1 unidad", badgeText: "Envío gratis", price: Math.round(currentPrice / 100) }];
    }
    selectedOffer = offer;

    offersEl.innerHTML = [
      '<div class="cod-form__offers-head">',
      '<div><strong>' + escapeHtml(offer.name || offer.titleAr || "Elige tu oferta") + '</strong>',
      '<span>' + escapeHtml(offer.descriptionAr || "Envío gratis y pago contra entrega") + '</span></div>',
      '<em>' + escapeHtml(offer.badgeText || "Envío gratis") + '</em>',
      "</div>",
      '<div class="cod-form__offer-list">',
      tiers.map(function (tier, index) {
        var qty = Number(tier.quantity || tier.qty || 1);
        var selected = index === 0 ? " is-selected" : "";
        var tierPrice = Number(tier.price || 0);
        var compareAt = Number(tier.compareAtPrice || 0);
        var image = tier.imageUrl
          ? '<img src="' + escapeHtml(tier.imageUrl) + '" alt="">'
          : '<i class="cod-form__offer-thumb" aria-hidden="true"></i>';
        var rawLabel = (tier.labelFr || tier.labelAr || ("Cantidad " + qty)).replace(/\s*(?:GTQ|USD|PAB|CRC|Q|\$)\b/gi, "").trim();
        var priceHtml = tierPrice
          ? '<strong class="cod-form__offer-price">' + formatMoney(tierPrice * 100) + (compareAt ? '<del>' + formatMoney(compareAt * 100) + '</del>' : "") + '</strong>'
          : '<b>' + qty + "x</b>";
        return (
          '<button type="button" class="cod-form__offer' + selected + '" data-tier-index="' + index + '">' +
          image +
          '<span><strong>' + escapeHtml(rawLabel) + '</strong>' +
          (tier.badgeText ? '<small>' + escapeHtml(tier.badgeText.replace(/\s*(?:GTQ|USD|PAB|CRC|Q|\$)\b/gi, "")) + '</small>' : "") +
          '</span>' + priceHtml + '</button>'
        );
      }).join(""),
      "</div>",
    ].join("").replace(/\s*(?:GTQ|USD|PAB|CRC|Q|\$)\b/gi, "");

    selectedTier = tiers[0];
    quantityInput.value = Number(selectedTier.quantity || selectedTier.qty || 1);
    offersEl.style.display = "";
    offersEl.classList.remove("cod-step-hidden");
    offersEl.querySelectorAll(".cod-form__offer").forEach(function (button) {
      button.addEventListener("click", function () {
        offersEl.querySelectorAll(".cod-form__offer").forEach(function (el) {
          el.classList.remove("is-selected");
        });
        button.classList.add("is-selected");
        selectedTier = tiers[Number(button.dataset.tierIndex || 0)];
        quantityInput.value = Number(selectedTier.quantity || selectedTier.qty || 1);
        updatePriceDisplay();
        firePixelEvent("AddToCart");
      });
    });
    updatePriceDisplay();
    if (stepperInitialized) {
      renderStep();
    }
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, function (char) {
      return {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#039;",
      }[char];
    });
  }

  // ─── Locations ───
  function populateLocationOptions() {
    if (!wilayaSelect) return;
    var currentWilaya = wilayaSelect.value;
    wilayaSelect.innerHTML = '<option value="">' + getFieldPlaceholder("wilaya", "Selecciona departamento") + "</option>";
    wilayasData.forEach(function (w) {
      var opt = document.createElement("option");
      opt.value = w.id;
      opt.textContent = w.nameFr || w.nameAr;
      wilayaSelect.appendChild(opt);
    });
    if (currentWilaya && wilayasData.some(function (w) { return w.id === currentWilaya; })) {
      wilayaSelect.value = currentWilaya;
    }
    updateMoughataaOptions();
  }

  function initLocationSelector() {
    if (!wilayaSelect || locationListenerReady) return;
    locationListenerReady = true;
    wilayaSelect.addEventListener("change", updateMoughataaOptions);
  }

  function updateMoughataaOptions() {
      if (!wilayaSelect || !moughataaSelect) return;
      var wilayaId = wilayaSelect.value;
      var currentMoughataa = moughataaSelect.value;
      moughataaSelect.innerHTML = '<option value="">' + getFieldPlaceholder("moughataa", "Selecciona municipio") + "</option>";
      moughataaSelect.disabled = true;

      if (!wilayaId) {
        shippingCost = 0;
        updatePriceDisplay();
        return;
      }

      var wilaya = wilayasData.find(function (w) { return w.id === wilayaId; });
      if (wilaya && wilaya.moughataas) {
        wilaya.moughataas.forEach(function (m) {
          var opt = document.createElement("option");
          opt.value = m.id;
          opt.textContent = m.nameFr || m.nameAr;
          moughataaSelect.appendChild(opt);
        });
        moughataaSelect.disabled = false;
        if (
          currentMoughataa &&
          wilaya.moughataas.some(function (m) { return m.id === currentMoughataa; })
        ) {
          moughataaSelect.value = currentMoughataa;
        }
      }

      shippingCost = 0;
      updatePriceDisplay();
  }

  function getFieldPlaceholder(key, fallback) {
    if (key === "wilaya") return "Selecciona tu provincia";
    if (key === "moughataa") return "Selecciona tu ciudad";
    var settings = (formConfig.fields && formConfig.fields[key]) || {};
    return settings.placeholder || fallback;
  }

  // ─── Quantity ───
  function initQuantity() {
    if (!quantityInput) return;
    if (!qtyMinus || !qtyPlus) {
      quantityInput.addEventListener("change", function () {
        var val = parseInt(quantityInput.value, 10);
        if (isNaN(val) || val < 1) quantityInput.value = 1;
        if (val > 100) quantityInput.value = 100;
        updatePriceDisplay();
      });
      return;
    }
    qtyMinus.addEventListener("click", function () {
      var val = parseInt(quantityInput.value, 10);
      if (val > 1) {
        quantityInput.value = val - 1;
        updatePriceDisplay();
        firePixelEvent("AddToCart");
      }
    });

    qtyPlus.addEventListener("click", function () {
      var val = parseInt(quantityInput.value, 10);
      if (val < 100) {
        quantityInput.value = val + 1;
        updatePriceDisplay();
        firePixelEvent("AddToCart");
      }
    });

    quantityInput.addEventListener("change", function () {
      var val = parseInt(quantityInput.value, 10);
      if (isNaN(val) || val < 1) quantityInput.value = 1;
      if (val > 100) quantityInput.value = 100;
      updatePriceDisplay();
    });
  }

  // ─── Variants ───
  function initVariants() {
    if (!variantSelects.length) return;

    variantSelects.forEach(function (select) {
      select.addEventListener("change", function () {
        updateSelectedVariant();
      });
    });
  }

  function updateSelectedVariant() {
    var selectedOptions = [];
    variantSelects.forEach(function (select) {
      selectedOptions.push(select.value);
    });

    var matched = variants.find(function (v) {
      for (var i = 0; i < selectedOptions.length; i++) {
        if (v["option" + (i + 1)] !== selectedOptions[i]) return false;
      }
      return true;
    });

    if (matched) {
      currentVariantId = String(matched.id);
      currentVariantTitle = matched.title;
      currentVariantSku = matched.sku || "";
      currentPrice = matched.price;
      currentComparePrice = matched.compare_at_price || 0;
      form.dataset.variantId = currentVariantId;
      form.dataset.variantTitle = currentVariantTitle;
      form.dataset.variantSku = currentVariantSku;
      form.dataset.productPrice = String(currentPrice);
      form.dataset.comparePrice = String(currentComparePrice);
      updatePriceDisplay();
    }
  }

  // ─── Price Display ───
  function updatePriceDisplay() {
    var qty = parseInt(quantityInput.value, 10) || 1;
    var subtotal = currentPrice * qty;
    var discountedSubtotal = applyTierDiscount(subtotal, qty);
    var total = discountedSubtotal + shippingCost * 100; // shippingCost in money units, price in cents

    unitPriceEl.textContent = formatMoney(discountedSubtotal);
    shippingPriceEl.textContent = shippingCost > 0 ? formatMoney(shippingCost * 100) : "Gratis";
    totalPriceEl.textContent = formatMoney(total);

    if (topPriceEl) {
      topPriceEl.textContent = formatMoney(currentPrice);
      topPriceEl.style.opacity = "1";
    }
    if (topComparePriceEl) {
      if (currentComparePrice > 0) {
        topComparePriceEl.textContent = formatMoney(currentComparePrice);
        topComparePriceEl.style.display = "block";
        topComparePriceEl.style.opacity = "1";
      } else {
        topComparePriceEl.style.display = "none";
      }
    }

    scrubAllPagePrices();
  }

  function scrubAllPagePrices() {
    document.querySelectorAll(".codm-sticky-price, #cod-sticky-price, #cod-product-card-price, .cod-sticky-cta__price, #cod-unit-price, #cod-total-price, #cod-top-price, #cod-top-compare-price, .cod-form__offer-price, .codm-price, .codm-compare, [class*='price']").forEach(function (el) {
      if (el.children.length === 0) {
        var raw = el.textContent || "";
        if (/\d+/.test(raw) && /(?:GTQ|USD|PAB|CRC|Q|\$)\b/i.test(raw)) {
          el.textContent = raw.replace(/\s*(?:GTQ|USD|PAB|CRC|Q|\$)\b/gi, "").trim();
        }
      }
    });
  }

  scrubAllPagePrices();
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scrubAllPagePrices);
  }
  window.addEventListener("load", scrubAllPagePrices);
  var scrubInterval = setInterval(scrubAllPagePrices, 300);
  setTimeout(function () { clearInterval(scrubInterval); }, 5000);

  function applyTierDiscount(subtotal, qty) {
    if (!selectedTier) return subtotal;
    var tierPrice = Number(selectedTier.price || 0);
    if (tierPrice > 0) return tierPrice * 100;
    var payQuantity = Number(selectedTier.payQuantity || 0);
    if (payQuantity > 0 && payQuantity < qty) {
      return currentPrice * payQuantity;
    }

    var discountValue = Number(selectedTier.discountValue || selectedTier.discount || 0);
    if (!discountValue) return subtotal;
    if (selectedTier.discountType === "FIXED_AMOUNT") {
      return Math.max(0, subtotal - discountValue * 100);
    }
    return Math.max(0, subtotal - subtotal * (discountValue / 100));
  }

  function formatMoney(cents) {
    return Math.round(cents / 100).toLocaleString("en-US");
  }

  // ─── Sticky CTA Observer ───
  function initStickyObserver() {
    if (!stickyCta) return;

    var stickyButton = stickyCta.querySelector(".cod-sticky-cta__btn");
    if (stickyButton) {
      stickyButton.addEventListener("click", function (event) {
        var placement = formConfig.formPlacement || "inline";
        if (placement === "popup" || placement === "sticky") return;
        event.preventDefault();
        form.scrollIntoView({ behavior: "smooth", block: "center" });
      });
    }

    var observer = new IntersectionObserver(
      function (entries) {
        var activeTag = document.activeElement ? document.activeElement.tagName : "";
        if (activeTag === "INPUT" || activeTag === "SELECT" || activeTag === "TEXTAREA") return;
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            stickyCta.classList.remove("cod-sticky-cta--visible");
            stickyCta.style.display = "none";
          } else {
            stickyCta.style.display = "block";
            requestAnimationFrame(function () {
              stickyCta.classList.add("cod-sticky-cta--visible");
            });
          }
        });
      },
      { threshold: 0.1 }
    );

    observer.observe(form);
  }

  // ─── Validation ───
  function validateForm() {
    var valid = true;
    clearErrors();
    var fields = formConfig.fields || {};

    // Validate Name
    if (isFieldRequired("name")) {
      var nameVal = nameInput.value.trim();
      if (!nameVal || nameVal.length < 3) {
        showFieldError("cod-name", "El nombre completo es obligatorio (mínimo 3 caracteres)");
        valid = false;
      }
    }

    // Validate Phone
    var phone = phoneInput.value;
    if (isFieldRequired("phone") && !validatePhoneNumber(phone, activeCountry)) {
      var digitsMsg = activeCountry === "PA" ? "7 u 8 dígitos" : "8 dígitos";
      showFieldError("cod-phone", "El número de teléfono no es válido (debe tener " + digitsMsg + ")");
      valid = false;
    } else if (isFieldEnabled("phone") && phone && !validatePhoneNumber(phone, activeCountry)) {
      var digitsMsg = activeCountry === "PA" ? "7 u 8 dígitos" : "8 dígitos";
      showFieldError("cod-phone", "El número de teléfono no es válido (debe tener " + digitsMsg + ")");
      valid = false;
    }

    // Validate PhoneAlt
    if (isFieldEnabled("phoneAlt")) {
      var phoneAlt = phoneAltInput.value;
      if (isFieldRequired("phoneAlt") && !validatePhoneNumber(phoneAlt, activeCountry)) {
        var digitsMsg = activeCountry === "PA" ? "7 u 8 dígitos" : "8 dígitos";
        showFieldError("cod-phone-alt", "El número de teléfono secundario no es válido (debe tener " + digitsMsg + ")");
        valid = false;
      } else if (phoneAlt && !validatePhoneNumber(phoneAlt, activeCountry)) {
        var digitsMsg = activeCountry === "PA" ? "7 u 8 dígitos" : "8 dígitos";
        showFieldError("cod-phone-alt", "El número de teléfono secundario no es válido (debe tener " + digitsMsg + ")");
        valid = false;
      }
    }

    // Validate Address
    if (isFieldRequired("address") && !addressInput.value.trim()) {
      showFieldError("cod-address", "La dirección es obligatoria");
      valid = false;
    }

    // Validate Postal Code
    if (isFieldEnabled("postalCode") && postalCodeInput) {
      if (isFieldRequired("postalCode") && !postalCodeInput.value.trim()) {
        showFieldError("cod-postal-code", "El código postal es obligatorio");
        valid = false;
      }
    }

    // Validate City
    if (isFieldEnabled("city") && cityInput) {
      if (isFieldRequired("city") && !cityInput.value.trim()) {
        showFieldError("cod-city", "La ciudad es obligatoria");
        valid = false;
      }
    }

    // Guatemala/LATAM (Wilaya -> Departamento, Moughataa -> Municipio)
    if (isFieldRequired("wilaya") && !wilayaSelect.value) {
      showFieldError("cod-wilaya", "Por favor selecciona el departamento");
      valid = false;
    }
    if (isFieldRequired("moughataa") && !moughataaSelect.value) {
      showFieldError("cod-moughataa", "Por favor selecciona el municipio");
      valid = false;
    }

    return valid;
  }

  function isFieldEnabled(key) {
    var settings = (formConfig.fields && formConfig.fields[key]);
    if (settings && typeof settings.enabled === "boolean") return settings.enabled;
    if (key === "phoneAlt") return Boolean(formConfig.secondaryPhoneEnabled);
    if (key === "address") return Boolean(formConfig.addressEnabled);
    if (key === "notes") return Boolean(formConfig.notesEnabled);
    if (key === "name" || key === "phone" || key === "address" || key === "city") return true;
    if (key === "wilaya" || key === "moughataa" || key === "postalCode" || key === "province") return false;
    return false;
  }

  function isFieldRequired(key) {
    if (!isFieldEnabled(key)) return false;
    var settings = (formConfig.fields && formConfig.fields[key]);
    if (settings && typeof settings.required === "boolean") return settings.required;
    if (key === "name" || key === "phone" || key === "address" || key === "city") return true;
    return false;
  }

  function showFieldError(fieldId, message) {
    var errorEl = document.getElementById(fieldId + "-error");
    var inputEl = document.getElementById(fieldId);
    if (errorEl) errorEl.textContent = message;
    if (inputEl) inputEl.classList.add("cod-form__input--error", "cod-form__select--error");
  }

  function clearErrors() {
    var errors = form.querySelectorAll(".cod-form__error");
    errors.forEach(function (el) { el.textContent = ""; });
    var inputs = form.querySelectorAll(".cod-form__input--error, .cod-form__select--error");
    inputs.forEach(function (el) {
      el.classList.remove("cod-form__input--error", "cod-form__select--error");
    });
    errorMessage.style.display = "none";
  }

  function normalizePhoneValue(value) {
    return String(value || "").replace(/\D/g, "");
  }

  // ─── Submit ───
  function handleSubmit() {
    if (submitting) return;
    if (!validateForm()) return;

    var currency = (form.dataset.currency || "Q").toUpperCase();

    firePixelEvent("InitiateCheckout");

    submitting = true;
    submitBtn.disabled = true;
    submitText.style.display = "none";
    submitSpinner.style.display = "inline-block";
    errorMessage.style.display = "none";

    var qty = parseInt(quantityInput.value, 10) || 1;
    var effectiveSubtotal = applyTierDiscount(currentPrice * qty, qty);
    var effectiveUnitPrice = effectiveSubtotal / qty / 100;
    var offerNote = selectedTier ? "Oferta: " + (selectedTier.labelFr || selectedTier.labelAr || selectedTier.label || "") : "";
    var offerId = selectedOffer && selectedOffer.id ? String(selectedOffer.id) : "";

    var customFieldsData = {};
    if (Array.isArray(formConfig.customFields) && formConfig.customFields.length > 0) {
      formConfig.customFields.forEach(function (cf) {
        if (!cf.enabled) return;
        var el = document.getElementById("cod-custom-" + cf.id);
        if (el && el.value) {
          var val = el.value.trim();
          if (val) {
            customFieldsData[cf.label] = val;
          }
        }
      });
    }

    var payload = {
      customerName: isFieldEnabled("name") ? nameInput.value.trim() : "",
      customerPhone: normalizePhoneValue(phoneInput.value),
      customerPhoneAlt: isFieldEnabled("phoneAlt") ? normalizePhoneValue(phoneAltInput.value) || "" : "",
      wilayaId: isFieldEnabled("wilaya") ? wilayaSelect.value : "",
      moughataaId: isFieldEnabled("moughataa") ? moughataaSelect.value : "",
      address: isFieldEnabled("address") ? addressInput.value.trim() : "",
      postalCode: isFieldEnabled("postalCode") && postalCodeInput ? postalCodeInput.value.trim() : "",
      city: isFieldEnabled("city") && cityInput ? cityInput.value.trim() : "",
      province: isFieldEnabled("province") && provinceSelect ? provinceSelect.value : "",
      notes: [isFieldEnabled("notes") ? notesInput.value.trim() : "", offerNote].filter(Boolean).join(" - "),
      customFields: customFieldsData,
      shopifyProductId: productId,
      shopifyVariantId: currentVariantId,
      productTitle: productTitle,
      variantTitle: currentVariantTitle || "",
      sku: currentVariantSku || currentVariantId || productId,
      productImage: productImage || "",
      quantity: qty,
      unitPrice: effectiveUnitPrice,
      upsellOfferId: offerId,
      utm_source: sessionStorage.getItem("utm_source") || "",
      utm_medium: sessionStorage.getItem("utm_medium") || "",
      utm_campaign: sessionStorage.getItem("utm_campaign") || "",
      utm_content: sessionStorage.getItem("utm_content") || "",
      utm_term: sessionStorage.getItem("utm_term") || "",
    };

    fetch(proxyUrl + "/orders", {
      method: "POST",
      cache: "no-store",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        submitting = false;
        submitBtn.disabled = false;
        submitText.style.display = "inline";
        submitSpinner.style.display = "none";

        if (data.error) {
          errorText.textContent = data.error;
          errorMessage.style.display = "block";
          return;
        }

        // Hide form fields, show success
        var fields = form.querySelectorAll(
          ".cod-form__header, .cod-form__price-display, .cod-form__variants, .cod-form__field, .cod-form__row, .cod-form__submit"
        );
        fields.forEach(function (el) { el.style.display = "none"; });

        document.getElementById("cod-order-number").textContent = data.orderNumber;
        successMessage.style.display = "block";

        firePixelEvent("Purchase", {
          value: data.total,
          currency: currency,
          content_ids: [productId],
          order_id: data.orderNumber,
          quantity: qty,
        });

        window.location.href =
          proxyUrl +
          "/thank-you?t=" +
          encodeURIComponent(data.thankYouToken || "");
      })
      .catch(function () {
        submitting = false;
        submitBtn.disabled = false;
        submitText.style.display = "inline";
        submitSpinner.style.display = "none";
        errorText.textContent = "Ocurrió un error. Por favor intente de nuevo.";
        errorMessage.style.display = "block";
      });
  }

  // ─── Focus tracking ───
  var checkoutTracked = false;
  [nameInput, phoneInput].forEach(function (el) {
    if (el) {
      el.addEventListener("focus", function () {
        if (!checkoutTracked) {
          checkoutTracked = true;
          firePixelEvent("InitiateCheckout");
        }
      });
    }
  });

  // ─── Pixel Events ───
  function initPixelViewContent() {
    var currency = (form.dataset.currency || "MRU").toUpperCase();
    firePixelEvent("ViewContent", {
      content_ids: [productId],
      content_type: "product",
      content_name: productTitle,
      value: currentPrice / 100,
      currency: currency,
    });
  }

  function firePixelEvent(eventName, data) {
    var pixelSettings = formConfig.pixelSettings || {};
    if (eventName === "ViewContent" && pixelSettings.viewContent === false) return;
    if (eventName === "AddToCart" && pixelSettings.addToCart === false) return;
    if (eventName === "InitiateCheckout" && pixelSettings.initiateCheckout === false) return;
    if (eventName === "Purchase" && pixelSettings.purchase === false) return;

    if (!pixelsReady) initPixels();
    data = data || {};
    data.content_ids = data.content_ids || [productId];
    data.content_type = data.content_type || "product";
    data.content_name = data.content_name || productTitle;
    data.currency = data.currency || (form.dataset.currency || "MRU").toUpperCase();
    data.value = Number(data.value || data.price || currentPrice / 100) || 0;

    var eventId =
      data.event_id ||
      data.eventID ||
      (data.order_id ? "cod-Purchase-" + data.order_id : "") ||
      [
        "cod",
        eventName,
        productId || "product",
        data.order_id || data.orderNumber || "",
        Math.floor(Date.now() / 1000),
      ].join("-");
    data.event_id = eventId;
    data.eventID = eventId;

    if (pixelSettings.deduplicateEvents !== false) {
      var dedupeKey = eventName + ":" + eventId;
      if (pixelEventKeys[dedupeKey]) return;
      pixelEventKeys[dedupeKey] = true;
    }

    // Meta Pixel
    if (pixelEnabled("meta", eventName) && typeof window.fbq === "function") {
      var metaData = {
        content_ids: data.content_ids,
        content_type: data.content_type,
        content_name: data.content_name,
        value: data.value,
        currency: data.currency,
        num_items: Number(data.quantity || quantityInput.value || 1) || 1,
      };
      if (data.order_id) metaData.order_id = data.order_id;
      window.fbq("track", eventName, metaData, { eventID: eventId });
    }

    // TikTok Pixel
    if (pixelEnabled("tiktok", eventName) && window.ttq && window.ttq.track) {
      var ttMap = {
        ViewContent: "ViewContent",
        AddToCart: "AddToCart",
        InitiateCheckout: "InitiateCheckout",
        Purchase: "CompletePayment",
      };
      window.ttq.track(ttMap[eventName] || eventName, {
        content_id: String(data.content_ids[0] || productId),
        content_type: data.content_type,
        content_name: data.content_name,
        value: data.value,
        currency: data.currency,
        quantity: Number(data.quantity || quantityInput.value || 1) || 1,
      }, { event_id: eventId });
    }

    // Snapchat Pixel
    if (pixelEnabled("snapchat", eventName) && typeof window.snaptr === "function") {
      var snapMap = {
        ViewContent: "VIEW_CONTENT",
        AddToCart: "ADD_CART",
        InitiateCheckout: "START_CHECKOUT",
        Purchase: "PURCHASE",
      };
      window.snaptr("track", snapMap[eventName] || eventName, {
        item_ids: data.content_ids,
        item_category: data.content_type,
        price: data.value,
        currency: data.currency,
        transaction_id: data.order_id || eventId,
      });
    }

    // Google Analytics
    if (pixelEnabled("google", eventName) && typeof window.gtag === "function") {
      var gaMap = {
        ViewContent: "view_item",
        AddToCart: "add_to_cart",
        InitiateCheckout: "begin_checkout",
        Purchase: "purchase",
      };
      window.gtag("event", gaMap[eventName] || eventName, {
        transaction_id: data.order_id || eventId,
        value: data.value,
        currency: data.currency,
        items: [
          {
            item_id: String(data.content_ids[0] || productId),
            item_name: data.content_name,
            quantity: Number(data.quantity || quantityInput.value || 1) || 1,
            price: data.value,
          },
        ],
      });
    }

    if (pixelSettings.debugMode && window.console) {
      console.info("[COD Pixels]", eventName, data);
    }
  }

  function pixelEnabled(platform, eventName) {
    var settings = formConfig.pixelSettings || {};
    var platformSettings = settings[platform] || {};
    if (platformSettings.enabled === false) return false;
    var keyMap = {
      ViewContent: "viewContent",
      AddToCart: "addToCart",
      InitiateCheckout: "initiateCheckout",
      Purchase: "purchase",
    };
    var key = keyMap[eventName];
    if (key && platformSettings[key] === false) return false;
    return true;
  }

  function initPixels() {
    if (pixelsReady) return;
    pixelsReady = true;
    var settings = formConfig.pixelSettings || {};

    if (pixelIds.meta && settings.meta?.enabled !== false) {
      initMetaPixel(String(pixelIds.meta), settings.meta || {});
    }
    if (pixelIds.tiktok && settings.tiktok?.enabled !== false) {
      initTikTokPixel(String(pixelIds.tiktok), settings.tiktok || {});
    }
    if (pixelIds.snapchat && settings.snapchat?.enabled !== false) {
      initSnapPixel(String(pixelIds.snapchat), settings.snapchat || {});
    }
    if (pixelIds.google && settings.google?.enabled !== false) {
      initGooglePixel(String(pixelIds.google), settings.google || {});
    }
  }

  function initMetaPixel(pixelId, settings) {
    if (!pixelId) return;
    if (!window.fbq) {
      !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
      n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}
      (window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
    }
    if (!window.__COD_META_PIXELS) window.__COD_META_PIXELS = {};
    if (!window.__COD_META_PIXELS[pixelId]) {
      window.fbq("init", pixelId);
      window.__COD_META_PIXELS[pixelId] = true;
    }
    if (settings.pageView !== false && !window.__COD_META_PAGE_VIEW_SENT) {
      window.fbq("track", "PageView");
      window.__COD_META_PAGE_VIEW_SENT = true;
    }
  }

  function initTikTokPixel(pixelId, settings) {
    if (!pixelId) return;
    if (!window.ttq) {
      !function(w,d,t){w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=
      ["page","track","identify","instances","debug","on","off","once","ready","alias",
      "group","enableCookie","disableCookie"];ttq.setAndDefer=function(t,e){t[e]=
      function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;
      i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t)
      {for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);
      return e};ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";
      ttq._i=ttq._i||{};ttq._i[e]=[];ttq._i[e]._u=i;ttq._t=ttq._t||{};ttq._t[e]=+new Date;
      ttq._o=ttq._o||{};ttq._o[e]=n||{};var o=d.createElement("script");o.type="text/javascript";
      o.async=!0;o.src=i+"?sdkid="+e+"&lib="+t;var a=d.getElementsByTagName("script")[0];
      a.parentNode.insertBefore(o,a)}}(window,document,'ttq');
    }
    if (!window.__COD_TIKTOK_PIXELS) window.__COD_TIKTOK_PIXELS = {};
    if (!window.__COD_TIKTOK_PIXELS[pixelId]) {
      window.ttq.load(pixelId);
      window.__COD_TIKTOK_PIXELS[pixelId] = true;
    }
    if (settings.pageView !== false && !window.__COD_TIKTOK_PAGE_VIEW_SENT) {
      window.ttq.page();
      window.__COD_TIKTOK_PAGE_VIEW_SENT = true;
    }
  }

  function initSnapPixel(pixelId, settings) {
    if (!pixelId) return;
    if (!window.snaptr) {
      !function(e,t,n){if(e.snaptr)return;var a=e.snaptr=function(){a.handleRequest?
      a.handleRequest.apply(a,arguments):a.queue.push(arguments)};a.queue=[];
      var s='script';var r=t.createElement(s);r.async=!0;
      r.src="https://sc-static.net/scevent.min.js";
      var u=t.getElementsByTagName(s)[0];u.parentNode.insertBefore(r,u)}
      (window,document);
    }
    if (!window.__COD_SNAP_PIXELS) window.__COD_SNAP_PIXELS = {};
    if (!window.__COD_SNAP_PIXELS[pixelId]) {
      window.snaptr("init", pixelId);
      window.__COD_SNAP_PIXELS[pixelId] = true;
    }
    if (settings.pageView !== false && !window.__COD_SNAP_PAGE_VIEW_SENT) {
      window.snaptr("track", "PAGE_VIEW");
      window.__COD_SNAP_PAGE_VIEW_SENT = true;
    }
  }

  function initGooglePixel(measurementId, settings) {
    if (!measurementId) return;
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function(){window.dataLayer.push(arguments);};
    if (!window.__COD_GOOGLE_PIXELS) window.__COD_GOOGLE_PIXELS = {};
    if (!window.__COD_GOOGLE_PIXELS[measurementId]) {
      var script = document.createElement("script");
      script.async = true;
      script.src = "https://www.googletagmanager.com/gtag/js?id=" + encodeURIComponent(measurementId);
      document.head.appendChild(script);
      window.gtag("js", new Date());
      window.gtag("config", measurementId, { send_page_view: settings.pageView !== false });
      window.__COD_GOOGLE_PIXELS[measurementId] = true;
    }
  }

  // ─── Theme Editor & Resilient Live Binding ───
  function rebindIfNeeded() {
    var activeTag = document.activeElement ? document.activeElement.tagName : "";
    if (activeTag === "INPUT" || activeTag === "SELECT" || activeTag === "TEXTAREA") return;

    var newForm = document.getElementById("cod-order-form");
    if (newForm && newForm !== form) {
      form = newForm;
      if (form && formConfig) {
        applyFormConfig();
        renderCustomFields();
      }
    }
  }

  document.addEventListener("shopify:section:load", rebindIfNeeded);
  document.addEventListener("shopify:section:select", rebindIfNeeded);
  setInterval(function () {
    rebindIfNeeded();
    updatePriceDisplay();
  }, 1000);
})();
